import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { Category } from '../new-equipment/category/models/category.model';
import { CategoryList } from '../new-equipment/home/models/categories.model';
import { OtherEquipments } from '../new-equipment/home/models/other-equipments.model';
import { Subcategory } from '../new-equipment/subcategory/models/subcategory.model';
import { Equipment } from '../new-equipment/subcategory/models/equipment.model';
import { EquipmentDetail } from '../new-equipment/detail/models/equipment.model';
import { CategoryCarousel } from '../home/models/new-category.model';
import { SubcategoryBrand } from '../new-equipment/subcategory-brand/models/subcategory-brand.model';

@Injectable({ providedIn: 'root' })
export class NewEquipmentService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiURL;

  private readonly defaultOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  // Helper genérico para GET
  private get<T>(endpoint: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}${endpoint}`, {
      ...this.defaultOptions,
      params: params ?? new HttpParams(),
    });
  }

  getExternalEquipments(): Observable<OtherEquipments[]> {
    return this.get(
      'other-equipments/',
      new HttpParams({
        fromObject: { ordering: 'order', is_active: 'true' },
      })
    );
  }

  getCategories(): Observable<CategoryList[]> {
    return this.get('categories/', new HttpParams().set('ordering', 'order'));
  }

  getCategoriesCarousel(): Observable<CategoryCarousel[]> {
    return this.get('categories-carousel/');
  }

  getCategory(slug: string): Observable<Category> {
    return this.get(`category-by-slug/${slug}/`);
  }

  getSubcategory(slug: string): Observable<Subcategory> {
    return this.get(`subcategory-by-slug/${slug}/`);
  }

  getEquipmentsBySlugSubCategory(slug: string): Observable<Equipment[]> {
    return this.get(`equipments-by-subcategory/${slug}/`);
  }

  getEquipmentBySlug(slug: string): Observable<EquipmentDetail> {
    return this.get(`equipment-by-slug/${slug}/`);
  }

  getBrandSubcategory(brandSlug: string, categorySlug: string): Observable<SubcategoryBrand> {
    return this.get(`brand/${brandSlug}/subcategory/${categorySlug}/description/`);
  }

  getEquipments(subcategory?: string, brand?: string): Observable<Equipment[]> {
    let params = new HttpParams();

    if (subcategory) params = params.set('subcategory', subcategory);
    if (brand) params = params.set('brand', brand);

    return this.get('equipments/', params);
  }

  getBrandsPerSubcategory(subcategories: string): Observable<any> {
    return this.get('brands/', new HttpParams().set('subcategories', subcategories));
  }
}
